// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"DimensionIcon-primaryButton-91_QdT","dimensionIcon":"DimensionIcon-dimensionIcon-3EMk75"};